import React, { useContext, useState } from 'react';

// Context
import GeneralContext from '../../../context/GeneralContext';

// Hooks
import { useTranslation } from 'react-i18next';

// Components
import Autocomplete from '../../UI/Autocomplete/Autocomplete';
import InputAddressAutocomplete from '../InputAddressAutocomplete/InputAddressAutocomplete';
import { getPlaceDetails, PlaceDetails, useAddressAutocomplete } from './useAddressAutocomplete';

// Models
interface Props {
    defaultValue?: string
    handleChangePlace: (details: PlaceDetails) => void
}

const AutocompleteAddress: React.FC<Props> = ({
    defaultValue,
    handleChangePlace,
}) => {

    const { t } = useTranslation();

    const [autocompleteText, setAutocompleteText] = useState('');

    const { GOOGLE_API_KEY } = useContext(GeneralContext);

    const { results, loading } = useAddressAutocomplete(autocompleteText, { apiKey: GOOGLE_API_KEY });

    const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        setAutocompleteText(e.target.value);
    }

    const handleSelectPlace = async (id: string) => {
        const details = await getPlaceDetails(id);
        handleChangePlace(details)
    }


    return (
        < Autocomplete
            renderInput={(props) =>
                <InputAddressAutocomplete
                    onChange={handleChangeInput}
                    {...props}
                    defaultLabel={defaultValue}
                />
            }
            emptyOptionsMessage={loading ? `${t('loading')}...` : (t('no_options_available') as string)}
            options={results.map(r => ({ id: r.placeId, label: r.description }))}
            onChange={handleSelectPlace}
        />
    );
};

export default AutocompleteAddress;